'use strict';
const angular = require('angular');

/*@ngInject*/
export function VoterGroupsService($resource) {
  return $resource('/api/voter-groups/:id', {
    name: '@_id'
  },{
    getWithData: {
      method: 'GET',
      url: "/api/voter-groups/:id/data"
    },
    getWithDataSS: {
      method: 'POST',
      url: "/api/voter-groups/:id/data/datatables"
    },
    getWithDataSuite: {
      method: 'GET',
      url: "/api/voter-groups/suite/:id/data"
    },
    querySuite: {
      method: 'GET',
      url: "/api/voter-groups/suite",
      isArray: true
    },
    update: {
      method: 'PUT'
    },
    updateCache: {
      method: 'POST',
      url: "/api/voter-groups/:id/update-cache"
    },
    getStats: {
      method: 'GET',
      url: "/api/voter-groups/:id/stats"
    }
  });
}


export default angular.module('conduu.VoterGroupsService', [])
  .factory('VoterGroupsService', VoterGroupsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/voter-groups/voter-groups.service.js